import { render, staticRenderFns } from "./vbConfirm.vue?vue&type=template&id=62f11e70&scoped=true&lang=pug&"
import script from "./vbConfirm.vue?vue&type=script&lang=js&"
export * from "./vbConfirm.vue?vue&type=script&lang=js&"
import style0 from "./vbConfirm.vue?vue&type=style&index=0&id=62f11e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f11e70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f11e70')) {
      api.createRecord('62f11e70', component.options)
    } else {
      api.reload('62f11e70', component.options)
    }
    module.hot.accept("./vbConfirm.vue?vue&type=template&id=62f11e70&scoped=true&lang=pug&", function () {
      api.rerender('62f11e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/dialog/vbConfirm.vue"
export default component.exports